import React from 'react';
import ReactDOM from 'react-dom';
import {
  Spinner,
} from '@genie-ui/react';

function FullscreenLoader() {
  return ReactDOM.createPortal(
    <div className="progress-pptCyber">
      <Spinner />
    </div>,
    document.body,
  );
}

export default FullscreenLoader;
